var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.8945,
    height: 100.7802,
    viewBox: "0 0 109.8945 100.7802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8c2332;}.cls-2{fill:#414042;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wordmark"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.975 48.882 22.398 48.882 22.398 42.53 50.343 42.53 22.398 22.513 22.398 0 54.685 24.971 86.975 0 86.975 22.513 59.03 42.53 86.975 42.53 86.975 48.882"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.918 76.698 36.175 58.849 26.883 58.849 7.53 79.3 7.53 58.849 0 58.849 0 100.282 7.53 100.282 7.53 88.266 13.768 81.851 27.705 100.223 27.75 100.282 36.886 100.282 18.918 76.698"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.4892,67.2675a12.6132,12.6132,0,0,0-3.122-4.3662,13.962,13.962,0,0,0-4.9453-2.792,20.3468,20.3468,0,0,0-6.4834-.9668H39.7138V100.208h7.4668V87.0937h7.9463a22.0755,22.0755,0,0,0,6.3887-.8974,15.81,15.81,0,0,0,5.23-2.6866,12.5879,12.5879,0,0,0,3.5381-4.3808,13.7324,13.7324,0,0,0,1.2988-6.1016v-.1152A14.1177,14.1177,0,0,0,70.4892,67.2675ZM47.1806,66.0234h8.1768a10.1642,10.1642,0,0,1,6.3154,1.8018,6.3046,6.3046,0,0,1,2.3262,5.3183v.126a6.5106,6.5106,0,0,1-2.3066,5.13,9.4594,9.4594,0,0,1-6.335,1.9951H47.1806Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.417,59.0117v23.66c0,3.7178-.9063,6.545-2.6953,8.4043a9.822,9.822,0,0,1-7.417,2.8174,9.6679,9.6679,0,0,1-7.4678-2.9306c-1.793-1.9424-2.7022-4.8282-2.7022-8.5772V59.0117H74.6562v23.66a22.9929,22.9929,0,0,0,1.2373,7.8418,15.4849,15.4849,0,0,0,3.5332,5.6827,14.6974,14.6974,0,0,0,5.54,3.45,21.6434,21.6434,0,0,0,7.2226,1.1337,22.1716,22.1716,0,0,0,7.3135-1.1337,14.5385,14.5385,0,0,0,5.5684-3.4844,16.0337,16.0337,0,0,0,3.5664-5.8018,23.56,23.56,0,0,0,1.2568-8.039v-23.31Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpu);
export default __webpack_public_path__ + "static/media/KPU.db561bf230845ab3faf42a3f5372d13f.svg";
export { ForwardRef as ReactComponent };